import React, { useState, useContext, useEffect } from 'react'
import ProductFieldsView from '@/custom/components/organisms/Product/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import SettingContext from '@/product/context/setting/settingContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import CustomCommonContext from '@/custom/context/common/commonContext'
import commonContext from '@/product/context/common/commonContext'
import ProductContext from '@/product/context/product/productContext'
import AlertContext from '@/product/context/alert/alertContext'
import AuthContext from '@/product/context/auth/authContext'
import { handleRedirectInternal } from '@/custom/common/components'
const DynamicListing = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const [anotherArray, setAnotherArray] = useState([])
    const { project_dynamicfields } = dynamicContext
    const customCommonContext = useContext(CustomCommonContext)
    const dashboardContext = useContext(commonContext)
    const { getMainDashboardData } = dashboardContext
    const history = useHistory()
    const [updated, setUpdated] = useState(false)
    const [categoryUpd, setCategoryUpd] = useState(false)
    const [updatedValues, setUpdatedValues] = useState({})
    const [warehouseList, setWarehouseList] = useState([])
    const [loading, setLoading] = useState(false)
    const { setAlert } = useContext(AlertContext)
    const productContext = useContext(ProductContext)
    const { all_products, getAllProducts, projectAction } = productContext
    const [asinMapData, setAsinMapData] = useState([])
    const settingcontext = useContext(SettingContext)
    const [homeMapData, setHomeMapData] = useState([])
    const { alldata_all_dropdown, getGlobalVariable } = customCommonContext
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const [data, setData] = useState({
        popup: false,
        status: 'newTemplate',
        id: 0,
        projectType: 0,
    })

    const filterFields = {
        title: 1,
        date_added: 1,
        date_closed: 1,
        qty: 1,
        featured: 1,
        auction: 1,
        sprice: 1,
        rprice: 1,
        buynow: 1,
        bprice: 1,
        // reverseauction: 1,
        asin_price: 1,
        uploadimages: 1,
        desc_proc: 1,
        location_id: 1,
        conditionTypeId: 1,
        category: 1,
        sub_category: 1,
        // dimension_length: 1,
        // dimension_width: 1,
        // dimension_height: 1,
        // dimension_unit: 1,
        // weight_value: 1,
        // weight_unit: 1,
        mpn: 1,
        upc: 1,
        bin_location: 1,
        // customer_tags: 1,
        brand: 1,
        // print_bin: 1,
        // print_label: 1,
        // low_estimate: 1,
        // high_estimate: 1,
        // lot_no: 1,
        // notes_listing: 1,
        home_depot: 1,
        upc_id: 1,
        asin: 1,
        manufacturer: 1,
        // local_pickup_dates: 1,
        // local_pickup_start_hour: 1,
        // local_pickup_end_hour: 1,
        // local_pickup_slot_timeframe: 1,
        // local_pickup_appt_per_slot: 1,
        location: 1,
        scan_lpn_number: 1,
        pickup_deadline_days: 1,
        pickup_deadline_text: 1,
        color_size: 1,
        material: 1,
        item_detail: 1,
        // condition_text: 1,
        // barcode_container: 1,
        // address: 1,
        // titleaddress: 1,
        // scraped_price: 1,
        // barcode: 1,
        // supply: 1,
        // container: 1,
        // pallet: 1,
        // initial_container: 1,
        // big_parent_container: 1,
        // suggested_retail: 1,
        // size: 1,
        // category_text: 1,
        // picked_up: 1,
        // piece_rate: 1,
        // quantity_in_lot: 1,
        // created_by_external: 1,
        // external_url: 1,
        // sub_variant: 1,
        // item_tags: 1,
        // processor_name: 1,
        // warehouse_id: 1,
        item_id: 1,
        // status: 1,
        truck_code: 1,
        warehouse_name: 1,
        disclaimer: 1,
    }

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const categoryFilter = (value, fieldname) => {
        if (value) {
            let arrayData = [...project_dynamicfields]
            let filterValue = ''
            arrayData.map((data, index) => {
                if (data.type === 'select') {
                    if (value !== null) {
                        if (!data.diff_value) {
                            let idValue = {}
                            idValue =
                                alldata_all_dropdown &&
                                alldata_all_dropdown.filter(
                                    (item) =>
                                        item.description === `${value}` &&
                                        item.variable === `${fieldname}` &&
                                        item.active == 1
                                )
                            if (idValue.length) {
                                let values = idValue[0]
                                filterValue = values.id
                            }
                        }
                    }
                }
            })
            if (filterValue !== '') {
                console.log(filterValue, 'filterrrrr')
                return filterValue
            } else {
                searchTableAction(
                    {
                        id: 0,
                        value: null,
                        description: value,
                        variable: fieldname,
                        table: 'data_all_dropdown',
                        active: 1,
                    },
                    false,
                    'category_update'
                )
            }
        }
    }

    useEffect(() => {
        searchTableFetch(
            {
                primaryTable: 'warehouse',
            },
            'warehouse_data'
        )
    }, [])

    useEffect(() => {
        if (search_fetch_data && search_fetch_data?.from === 'warehouse_data') {
            setWarehouseList(search_fetch_data)
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (props.cyber) {
            if (props?.data) {
                setData((data) => {
                    return {
                        ...data,
                        popup: props?.data?.popup,
                        status: props?.data?.status,
                        id: props?.data?.id ? props?.data?.id : 0,
                        projectType: 0,
                    }
                })
            }
        } else {
            if (props?.match?.params?.id && props?.match?.params?.status) {
                setData({
                    popup: true,
                    status: props?.match?.params?.status,
                    id: props?.match?.params?.id,
                    projectType: 0,
                })
            }
        }
        getMainDashboardData(global.customDashboardFilter)
    }, [props?.match?.params?.id, props?.match?.params?.status, props?.data])

    const validateFunc = (data) => {
        setUpdatedValues(data)
        setLoading(true)
        const payload = {
            ...data,
            title: data.title ? data.title.trim() : data.title,
            // market_status:
            // data.status === 'live' || data.status === 'ready'
            //     ? 'open'
            //     : 'draft',
            // is_approved:
            //     data.status === 'live' || data.status === 'ready' ? 1 : 0,
        }
        projectAction(payload)
        setUpdatedValues({})
        // getAllProducts(
        //     {
        //         page: 1,
        //         limit: 20,
        //         order: '',
        //         orderby: '',
        //         filters: {
        //             lpn_number: {
        //                 value: data.scan_lpn_number,
        //                 type: 'in',
        //                 field: 'it.scan_lpn_number',
        //             },
        //         },
        //     },
        //     'scan_lpn'
        // )
    }

    // useEffect(() => {
    //     if (all_products && all_products.from == 'scan_lpn') {
    //         console.log('getAllProducts ', all_products)
    //         // if (
    //         //     all_products.records.length &&
    //         //     all_products.records[0].id != updatedValues.id
    //         // ) {
    //         //     setAlert('LPN number already exists', 'error')
    //         //     setLoading(false)
    //         // } else {
    //         updatedValues.location_id = updatedValues.location || 0
    //         projectAction(updatedValues)
    //         setLoading(true)
    //         // }
    //     }
    // }, [all_products])

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (
                    responseStatusSetting.from === 'category_update' &&
                    updated
                ) {
                    setUpdated(false)
                    console.log('hellloooo')
                    getGlobalVariable()
                    setTimeout(() => {
                        setCategoryUpd(true)
                    }, 4000)
                    // setReload(!reload)
                    clearResponseCommuncation()
                }
            }
        }
    }, [responseStatusSetting, updated])
    useEffect(() => {
        if (alldata_all_dropdown && categoryUpd) {
            anotherArray.map((data) => {
                if (data.name == 'category') {
                    data.initialDefault = categoryFilter(
                        props.data.data.category,
                        'category'
                    )
                }
            })
            setFieldValue(anotherArray)
            setCategoryUpd(false)
        }
    }, [alldata_all_dropdown, categoryUpd])
    useEffect(() => {
        if (
            props.data?.data &&
            anotherArray.length &&
            Object.keys(props.data.data).length
        ) {
            setCategoryUpd(false)
            console.log('how many times', props.data.data)
            let allData = [...anotherArray]
            const cyberData = props.data?.data
            allData.map((item) => {
                if (props?.cyber && cyberData) {
                    if (
                        item.name === 'category' &&
                        cyberData.category !== '' &&
                        !updated
                    ) {
                        let category = categoryFilter(
                            cyberData.category,
                            'category'
                        )
                        if (category) {
                            item.initialDefault = category
                        }
                        setUpdated(true)

                        console.log(
                            item.initialDefault,
                            cyberData.category,
                            'allDetails'
                        )
                    }
                    if (item.name === 'title') {
                        item.initialDefault = cyberData.title
                    }
                    if (item.name === 'desc_proc') {
                        item.initialDefault = cyberData.description
                    }
                    if (item.name === 'uploadimages') {
                        item.initialDefault = [cyberData.image]
                    }
                }
            })

            setFieldValue(allData)
        }
    }, [props.data?.data, anotherArray])
    const [fieldValue, setFieldValue] = useState([])

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let projectDynamicArray = [...project_dynamicfields]
            let dynamicValueAssign = []
            let projectType = props?.data?.projectType
            console.log('something 1 ', projectType, projectDynamicArray)
            projectDynamicArray
                .filter((data) => data.active === 1 && filterFields[data.name])
                .map((item) => {
                    if (item.view_on && projectType && false) {
                        if (
                            item.view_on.includes(projectType) ||
                            item.view_on.includes('10')
                        ) {
                            if (item.name === 'qty') {
                                item.initialDefault = 1
                            } else if (item.name === 'sprice') {
                                // item.initialDefault = 1
                            } else if (item.type == 'uploadDropZone') {
                                item.isCrop = true
                            } else if (
                                item.name === 'location' &&
                                props.seller &&
                                user?.emp_type === 'seller'
                            ) {
                                item.seller = true
                                item.admin_id = user?.admin_id
                                item.emp_location = user?.emp_location
                            } else if (item.name === 'category') {
                                item.isCategory = true
                            } else if (item.name === 'sub_category') {
                                item.sub_field = 'category'
                                item.isSubCategory = true
                            }
                            dynamicValueAssign.push(item)
                        }
                    } else {
                        if (item.name === 'qty') {
                            item.initialDefault = 1
                        } else if (item.name === 'sprice') {
                            // item.initialDefault = 1
                        } else if (item.type == 'uploadDropZone') {
                            item.isCrop = true
                        } else if (
                            item.name === 'location' &&
                            props.seller &&
                            user?.emp_type === 'seller'
                        ) {
                            item.seller = true
                            item.admin_id = user?.admin_id
                            item.emp_location = user?.emp_location
                        } else if (item.name === 'category') {
                            item.isCategory = true
                        } else if (item.name === 'sub_category') {
                            item.sub_field = 'category'
                            item.isSubCategory = true
                        }
                        dynamicValueAssign.push(item)
                    }
                    if (
                        item.name === 'sales_tax_check' ||
                        item.name === 'auction'
                    ) {
                        item.initialDefault = 1
                    }
                })
            dynamicValueAssign.push(
                // {
                //     label: 'Warehouse',
                //     placeholder: 'Select Warehouse',
                //     type: 'select',
                //     active: 1,
                //     class: 'col-sm-4 col-12',
                //     options: warehouseList?.records?.map((location) => {
                //         return {
                //             show: location.name,
                //             value: location.warehouse_id,
                //         }
                //     }),
                //     is_required: 1,
                //     defaultOptionValue: 'Select Warehouse',
                //     name: 'warehouse_id',
                // },
                // {
                //     label: 'Status',
                //     placeholder: 'Select Status',
                //     type: 'select',
                //     active: 1,
                //     class: 'col-sm-4 col-12',
                //     options: [
                //         { show: 'Live', value: 'live' },
                //         { show: 'Fix', value: 'fix' },
                //         { show: 'Ready', value: 'ready' },
                //         { show: 'Pending', value: 'pending' },
                //         { show: 'Delete', value: 'delete' },
                //     ],
                //     is_required: 1,
                //     defaultOptionValue: 'Select Status',
                //     name: 'status',
                // },
                // {
                //     label: 'Image Link',
                //     placeholder: 'Enter Image Link',
                //     name: 'avatar',
                //     value: '',
                //     type: 'text',
                //     active: 1,
                // },
                // {
                //     label: 'Comment',
                //     placeholder: 'Enter Comment',
                //     class: 'col-sm-4 col-12',
                //     name: 'comment',
                //     value: '',
                //     type: 'text',
                //     active: 1,
                // },
                {
                    label: 'Enable Tax Calculation',
                    placeholder: 'Enable Tax Calculation',
                    class: 'col-sm-4 col-12',
                    name: 'sales_tax_check',
                    type: 'checkbox',
                    initialDefault: 1,
                    active: 1,
                },
                {
                    name: 'market_status',
                    value: 'draft',
                    type: 'default',
                    active: 1,
                },
                {
                    name: 'asin_id',
                    value: '',
                    type: 'default',
                    active: 1,
                },
                {
                    name: 'home_id',
                    value: '',
                    type: 'default',
                    active: 1,
                },
                {
                    name: 'auctiontype',
                    value: 'live',
                    type: 'default',
                    active: 1,
                },
                {
                    label: 'Keywords',
                    placeholder: 'Enter Keywords',
                    class: 'col-12',
                    type: 'tagsInput',
                    name: 'keywords',
                    options: [],
                    filter: false,
                    multiple: true,
                    active: 1,
                    view_page: 1,
                }
            )

            console.log(
                'something 2 ',
                projectType,
                projectDynamicArray,
                dynamicValueAssign
            )
            setFieldValue(dynamicValueAssign)
            setAnotherArray(dynamicValueAssign)
        }
    }, [project_dynamicfields, props.data, props.data?.data])

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }

    const closeFunction = (data) => {
        if (data && data?.market_status === 'draft') {
            handleRedirectInternal(history, `listing/draft`)
        } else if (data && data?.market_status === 'open') {
            handleRedirectInternal(history, `listing/open`)
        } else {
            history.goBack()
        }
    }

    return (
        <>
            <ProductFieldsView
                fieldValue={fieldValue}
                userId={props.userId}
                customDisableFields={['sprice', 'rprice']}
                data={props.data ? props.data : data}
                draftValidation={true}
                showasin={true}
                homeDepot={true}
                function={props.function}
                asinMapData={asinMapData}
                homeMapData={homeMapData}
                additionalFieldUpdate={additionalFieldUpdate}
                closeFunction={closeFunction}
                customFilter={props.customFilter}
                standalone={true}
                validate={true}
                loading={loading}
                validateFunc={validateFunc}
            />
        </>
    )
}

export default DynamicListing
